import { isDescendant } from "@app/utils/isDescendant";

export interface HeaderSearch {
  isMobileActive: boolean; // whether the mobile search is visible or hidden
  showMobileSearch: () => void;
  hideMobileSearch: () => void;

  isDesktopActive: boolean; // whether the desktop search is visible or hidden
  showDesktopSearch: () => void;
  hideDesktopSearch: () => void;
}

const SEARCH_MOBILE_WRAPPER_ID = "header-search-mobile-wrapper";
const SEARCH_MOBILE_BUTTON_ID = "header-search-button";
const SEARCH_DESKTOP_WRAPPER_ID = "header-search-desktop-wrapper";
const SEARCH_MOBILE_INPUT_QUERY = "#header-search-mobile input";

window.headerSearch = {
  isMobileActive: false,
  showMobileSearch: function () {
    const searchWrapper = document.getElementById(SEARCH_MOBILE_WRAPPER_ID);
    searchWrapper?.classList.remove("hide");
    searchWrapper?.classList.add("active");
    searchWrapper?.classList.add("reveal");
    const searchButton = document.getElementById(SEARCH_MOBILE_BUTTON_ID);
    searchButton?.classList.remove("reveal");
    searchButton?.classList.add("hide");
    setTimeout(() => {
      searchButton?.classList.add("active");
    }, 200);
  },
  hideMobileSearch: function () {
    window.headerSearch.isMobileActive = false;
    const searchWrapper = document.getElementById(SEARCH_MOBILE_WRAPPER_ID);
    searchWrapper?.classList.add("hide");
    searchWrapper?.classList.remove("reveal");
    setTimeout(() => {
      searchWrapper?.classList.remove("active");
      searchWrapper?.classList.remove("always-show");
    }, 200);
    const searchButton = document.getElementById(SEARCH_MOBILE_BUTTON_ID);
    searchButton?.classList.remove("active");
    searchButton?.classList.remove("hide");
    searchButton?.classList.add("reveal");
  },

  isDesktopActive: false,
  showDesktopSearch: function () {
    window.headerSearch.isDesktopActive = true;
    document.getElementById(SEARCH_DESKTOP_WRAPPER_ID)?.classList.remove("hidden");
  },
  hideDesktopSearch: function () {
    window.headerSearch.isDesktopActive = false;
    document.getElementById(SEARCH_DESKTOP_WRAPPER_ID)?.classList.add("hidden");
  },
};

const focusTextInput = (el) => {
  var __tempEl__ = document.createElement("input");
  __tempEl__.style.position = "relative";
  __tempEl__.style.top = el.offsetTop + "px";
  __tempEl__.style.left = el.offsetLeft + "px";
  __tempEl__.style.height = 0 + "!important";
  __tempEl__.style.opacity = 0;
  el.after(__tempEl__);
  __tempEl__.focus();
  setTimeout(() => {
    el.focus();
    el.click();
    __tempEl__.remove();
  }, 50);
};

window.focusTextInput = focusTextInput;

document.addEventListener<any>("show-mobile-search", (e) => {
  window.headerSearch.showMobileSearch();
  document.querySelector<HTMLInputElement>(SEARCH_MOBILE_INPUT_QUERY)?.focus();
  setTimeout(() => {
    window.headerSearch.isMobileActive = true;
  }, 0);
});

// when the user clicks outside of #header-search-mobile-wrapper, hide the mobile search.
document.addEventListener("click", function (event) {
  if (window.headerSearch.isMobileActive) {
    const searchWrapper = document.getElementById(SEARCH_MOBILE_WRAPPER_ID);
    if (searchWrapper && !isDescendant(searchWrapper, event.target)) {
      window.headerSearch.hideMobileSearch();
    }
  }
});

// when an element on the page is visible inside the viewport, hide the desktop search.
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      window.headerSearch.hideDesktopSearch();
    } else {
      window.headerSearch.showDesktopSearch();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // change the element selector based on requirements, this should typically be the hero search element
  const targetElement = document.querySelector(".section-search-hero");
  if (targetElement) {
    observer.observe(targetElement);
  }
});

let isHidden = document.querySelector("header")?.classList.contains("is-homepage");
window.addEventListener(
  "scroll",
  function () {
    if (!isHidden && !(this.oldScroll > this.scrollY)) {
      window.headerSearch.hideMobileSearch();
      isHidden = true;
    }
  },
  { passive: true },
);
